import axios from "axios";
import { ENDPOINTS, getBaseURL } from "data/endpoints";
import { getHeaders } from "data/headers";

import { OfferwallUrlResponse } from "./interface";

export const getInBrainOfferwallUrl =
  async (): Promise<OfferwallUrlResponse> => {
    try {
      const { data } = await axios.get(
        getBaseURL() + ENDPOINTS.INBRAIN_OFFERWALL_URL,
        {
          headers: getHeaders(),
        },
      );

      return data;
    } catch (e) {
      return {
        message: e.response?.data?.message,
        response: { url: "" },
        error: {},
      };
    }
  };
